import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { WeighmentDetailsReport } from './Pages';

export const WeighmentDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={WeighmentDetailsReport} />
    </Fragment>
)